import { QueryKeys } from '../queryKeys';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { AppDataContext } from '../../contexts/appData';

export const useGetPromPackagesSale = ({ enabled }) => {
  const { api } = useContext(AppDataContext);

  const { data } = useQuery({
    queryKey: [QueryKeys.PromPackagesSale],
    queryFn: () => api.getPromPackagesSale(),
    staleTime: 1000 * 60 * 60,
    enabled,
    placeholderData: (previousData) => previousData,
  });

  const promPackageSale = data?.data;

  return { promPackageSale: promPackageSale && Object.keys(promPackageSale).length !== 0 ? promPackageSale : null };
};
